import { z } from 'src/lib'
import {
    OperacionContraparteCuentaFields,
    OperacionContraparteFields,
    OperacionContraparteLimiteFields,
    OperacionContraparteLimitesAprobadosPaisFields, OperacionContraparteLimitesSectorComercialFields
} from './fields'
import {schemaCuentaContraparte} from "./types";

export const schemaOperacionContraparteUpdate = z.object({
    [OperacionContraparteFields.CodSectorComercial]: z.number(),
    [OperacionContraparteFields.FechaAprobacion]: z.date().optional().nullable(),
    [OperacionContraparteFields.FechaVencimiento]: z.date()
})

export type OperacionContraparteUpdate = z.infer<typeof schemaOperacionContraparteUpdate>

export const schemaOperacionContraparteInsert = z.object({
    [OperacionContraparteFields.CodPais]: z.number(),
    [OperacionContraparteFields.CodSectorComercial]: z.number(),
    [OperacionContraparteFields.FechaAprobacion]: z.date().optional().nullable(),
    [OperacionContraparteFields.FechaVencimiento]: z.date(),
    [OperacionContraparteFields.BitEnvio]: z.boolean(),
    [OperacionContraparteFields.Cuentas]: z.array(
        z.object({
            [OperacionContraparteCuentaFields.NroCuenta]: z.string(),
            [OperacionContraparteCuentaFields.RazonSocial]: z.string(),
            [OperacionContraparteCuentaFields.CodMoneda]: z.number(),
            [OperacionContraparteCuentaFields.ImporteConcertacion]: z.number(),
            [OperacionContraparteCuentaFields.ImporteDPV]: z.number(),
            [OperacionContraparteCuentaFields.ImporteFOP]: z.number()
        })
    )
})

export type OperacionContraparteInsert = z.infer<typeof schemaOperacionContraparteInsert>

export const schemaOperacionContraparteCuentaInsert = z.object({
    [OperacionContraparteCuentaFields.NroCuenta]: z.string(),
    [OperacionContraparteCuentaFields.RazonSocial]: z.string(),
    [OperacionContraparteCuentaFields.CodMoneda]: z.number(),
    [OperacionContraparteCuentaFields.ImporteConcertacion]: z.number(),
    [OperacionContraparteCuentaFields.ImporteDPV]: z.number(),
    [OperacionContraparteCuentaFields.ImporteFOP]: z.number()
})

export type OperacionContraparteCuentaInsert = z.infer<typeof schemaOperacionContraparteCuentaInsert>

export const schemaOperacionContraparteCuentaUpdate = z.object({
    [OperacionContraparteCuentaFields.NroCuenta]: z.string(),
    [OperacionContraparteCuentaFields.RazonSocial]: z.string(),
    [OperacionContraparteCuentaFields.CodMoneda]: z.number().optional()
})

export type OperacionContraparteCuentaUpdate = z.infer<typeof schemaOperacionContraparteCuentaUpdate>

export const schemaOperacionContraparteCuentaDetalleUpdate = z.object({
    [OperacionContraparteCuentaFields.ImporteConcertacion]: z.number().optional(),
    [OperacionContraparteCuentaFields.ImporteDPV]: z.number().optional(),
    [OperacionContraparteCuentaFields.ImporteFOP]: z.number().optional()
})

export type OperacionContraparteCuentaDetalleUpdate = z.infer<typeof schemaOperacionContraparteCuentaDetalleUpdate>


export const schemaOperacionContraparteLimiteAprobado = z.object({
    [OperacionContraparteLimiteFields.NroCuenta]: z.string(),
    [OperacionContraparteLimiteFields.RazonSocial]: z.string(),
    [OperacionContraparteLimiteFields.CodMoneda]: z.number(),
    [OperacionContraparteLimiteFields.DescMoneda]: z.string(),
    [OperacionContraparteLimiteFields.SimboloMoneda]: z.string(),
    [OperacionContraparteLimiteFields.ImporteConcertacion]: z.number(),
    [OperacionContraparteLimiteFields.ImporteDPV]: z.number(),
    [OperacionContraparteLimiteFields.ImporteFOP]: z.number(),
    [OperacionContraparteLimiteFields.Sector]: z.string(),
    [OperacionContraparteLimiteFields.Estilo]: z.string().optional(),
    [OperacionContraparteLimiteFields.PermiteModificar]: z.boolean(),
    [OperacionContraparteLimiteFields.IdUsuarioAlta]: z.number(),
    [OperacionContraparteLimiteFields.FechaVencimiento]: z.coerce.date(),
    [OperacionContraparteLimiteFields.FechaUltMod]: z.coerce.date(),
    [OperacionContraparteLimiteFields.UsuarioUltMod]: z.string(),
    [OperacionContraparteLimiteFields.MensajeId]: z.number(),
    [OperacionContraparteLimiteFields.FechaAprobacion]: z.coerce.date().nullable(),
    [OperacionContraparteLimiteFields.CodSectorComercial]: z.number(),
    [OperacionContraparteLimiteFields.NombreSectorComercial]: z.string(),
});

export type OperacionContraparteLimiteAprobado = z.infer<typeof schemaOperacionContraparteLimiteAprobado>;


export const schemaOperacionContraparteLimitesAprobadosSectorComercial = z.object({
    [OperacionContraparteLimitesSectorComercialFields.CodSectorComercial]: z.number(),
    [OperacionContraparteLimitesSectorComercialFields.NombreSectorComercial]: z.string(),
    [OperacionContraparteLimitesSectorComercialFields.ListaLimites]: z.array(schemaOperacionContraparteLimiteAprobado),
});

export type OperacionContraparteLimitesAprobadosSectorComercial = z.infer<typeof schemaOperacionContraparteLimitesAprobadosSectorComercial>;

export const schemaOperacionContraparteLimitesAprobadosPais = z.object({
    [OperacionContraparteLimitesAprobadosPaisFields.FechaAlta]: z.coerce.date(),
    [OperacionContraparteLimitesAprobadosPaisFields.UsuarioAlta]: z.string(),
    [OperacionContraparteLimitesAprobadosPaisFields.MensajeId]: z.number(),
    [OperacionContraparteLimitesAprobadosPaisFields.NombrePais]: z.string(),
    [OperacionContraparteLimitesAprobadosPaisFields.CodPais]: z.number(),
    [OperacionContraparteLimiteFields.FechaAprobacion]: z.coerce.date().nullable(),
    [OperacionContraparteLimiteFields.FechaVencimiento]: z.coerce.date(),
    [OperacionContraparteLimitesAprobadosPaisFields.ListaSectores]: z.array(schemaOperacionContraparteLimitesAprobadosSectorComercial),
});

export type OperacionContraparteLimitesAprobadosPais = z.infer<typeof schemaOperacionContraparteLimitesAprobadosPais>;

export const schemaListaOperacionContraparteLimitesAprobadosPais = z.array(schemaOperacionContraparteLimitesAprobadosPais);